import { faunaAPI } from "../fauna-api";

export const getLocations = async () => faunaAPI.callFunction('get_all_Locations')